module.exports = __webpack_public_path__ + "img/objective-3.836165ce.jpg";